import { StateService } from '../../../services/state.service';
import { ScreenType } from '../../../models/enums.models';
import { MatIconModule } from '@angular/material/icon';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'summary-card',
  standalone: true,
  imports: [MatIconModule],
  templateUrl: './summary-card.component.html',
  styleUrl: './summary-card.component.css'
})
export class SummaryCardComponent {
    _readonly: boolean = false;

    @Input('isValid') _isValid: boolean | undefined;
    @Input('screen') _screen: ScreenType | undefined;

    constructor(private stateService: StateService) {
        this._readonly = stateService.formIsSubmitted; 
    }

    onNavigateTo(screen : ScreenType): void {
        this.stateService.navigateTo(screen!)
    }
}
